var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.694 32.174c-1.168 1.088-10.529 10.17-10.529 10.17l2.499 2.464c0 0 8.317-7.676 9.566-8.837 0.309-0.286 0.832-0.831 1.799-0.831h28.365v-3.928h-29.351c-0.858 0.001-1.671 0.337-2.349 0.961z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.499 10.823c3.326 0 5.141-2.303 5.141-5.141 0-2.837-2.303-5.138-5.141-5.138-2.839 0-5.14 2.301-5.14 5.138 0 2.838 2.301 5.141 5.14 5.141z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.877 19.657h1.724l-2.526 9.075h16.85l-2.528-9.075h1.724l2.622 9.075h4.454l-3.58-12.042c-0.473-1.663-2.576-4.609-6.217-4.609h-9.802c-3.639 0-5.74 2.946-6.217 4.609l-3.575 12.042h4.454l2.617-9.075z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.303 28.256l-4.525-8.437c0 0-0.266-0.402-0.759-0.163-0.443 0.214-0.243 0.713-0.243 0.713l1.501 2.865 0.934 1.785-1.077-0.485c-1.908-0.86-2.96-1.227-3.382-1.416-0.075-0.035-0.445-0.238-0.621-0.625-0.5-1.118-2.635-6.522-3.114-7.717-0.405-1.011-1.404-2.447-3.457-2.955-2.337-0.578-4.693 0.896-5.249 3.241l-3.189 13.441c-0.284 1.084-0.772 4.016-0.772 5.252 0 1.236 0.021 26.254 0.021 26.254 0.016 2.215 1.615 4.001 3.828 3.991 2.21-0.007 3.723-1.808 3.716-4.020 0 0-0.003-14.298-0.005-22.242l3.401-14.355c0.397 0.971 0.889 2.154 1.050 2.438 0.383 0.67 0.761 1.131 1.533 1.494 0 0 4.451 1.842 6.174 2.628 1.038 0.398 2.165 0.046 2.821-0.782l0.238-0.493 0.082 0.157c0 0 0.507 0.893 1.256 0.934 0.215-0.681-0.161-1.503-0.161-1.503z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.423 5.638c0 2.839-2.303 5.143-5.143 5.143-2.84 0-5.14-2.303-5.14-5.143 0-2.839 2.301-5.141 5.14-5.141 2.84 0 5.143 2.302 5.143 5.141z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.739 39.187l10.018-9.324-1.302-1.397-10.018 9.325z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIRegistration);
export default __webpack_public_path__ + "static/media/i-registration.9edd8420.svg";
export { ForwardRef as ReactComponent };